export function checkoutTag(obj) {
  window.gtag("event", "begin_checkout", obj);
}
